import { QueryClient } from "@tanstack/react-query";
import { DATA_CHANGED_EVENT } from "./dataSync";

// Cliente único partilhado. staleTime moderado — os dados contabilísticos não mudam
// ao segundo, e queremos menos refetches; as mutations invalidam o que interessa.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// Mantém os ecrãs React Query alinhados com as ações executadas tanto neste
// módulo como nas páginas legadas de App.js. Só as queries atualmente visíveis
// são recarregadas; as restantes ficam inválidas para a próxima abertura.
if (typeof window !== "undefined") {
  window.addEventListener(DATA_CHANGED_EVENT, () => {
    queryClient.invalidateQueries();
  });
}
